import Vue from 'vue'
import Component from 'vue-class-component'
import Router from 'vue-router'
import { Authority } from '@/shared/enums/authority'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
])
const Home = () => import('../core/home.vue')
const Error = () => import('../core/error/error.vue')
const JhiUserManagementComponent = () => import('../admin/user-management/user-management.vue')
const JhiConfigurationComponent = () => import('../admin/configuration/configuration.vue')
const JhiDocsComponent = () => import('../admin/docs/docs.vue')
const JhiHealthComponent = () => import('../admin/health/health.vue')
const JhiLogsComponent = () => import('../admin/logs/logs.vue')
const JhiAuditsComponent = () => import('../admin/audits/audits.vue')
const JhiMetricsComponent = () => import('../admin/metrics/metrics.vue')
const MarketplaceInfoComponent = () => import('../marketplace/info/info.vue')
const MarketPlaceUsersComponent = () => import('../marketplace/users/users.vue')
const ThorConfigComponent = () => import('../marketplace/thor/thor.vue')
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

Vue.use(Router)

export const marketPlaceRoutes = [
  {
    path: 'info',
    name: 'MarketplaceInfoComponent',
    component: MarketplaceInfoComponent,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: 'users',
    name: 'MarketPlaceUsersComponent',
    component: MarketPlaceUsersComponent,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: 'thor',
    name: 'ThorConfigComponent',
    component: ThorConfigComponent,
    meta: { authorities: [Authority.USER] },
  },
]

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/marketplace/users',
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true },
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true },
    },
    {
      path: '/admin/user-management',
      name: 'JhiUser',
      component: JhiUserManagementComponent,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: '/admin/docs',
      name: 'JhiDocsComponent',
      component: JhiDocsComponent,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: '/admin/audits',
      name: 'JhiAuditsComponent',
      component: JhiAuditsComponent,
      meta: { authorities: [Authority.SUPER_ADMIN] },
    },
    {
      path: '/admin/jhi-health',
      name: 'JhiHealthComponent',
      component: JhiHealthComponent,
      meta: { authorities: [Authority.SUPER_ADMIN] },
    },
    {
      path: '/admin/logs',
      name: 'JhiLogsComponent',
      component: JhiLogsComponent,
      meta: { authorities: [Authority.SUPER_ADMIN] },
    },
    {
      path: '/admin/jhi-metrics',
      name: 'JhiMetricsComponent',
      component: JhiMetricsComponent,
      meta: { authorities: [Authority.SUPER_ADMIN] },
    },
    {
      path: '/admin/jhi-configuration',
      name: 'JhiConfigurationComponent',
      component: JhiConfigurationComponent,
      meta: { authorities: [Authority.SUPER_ADMIN] },
    },
    {
      path: '/marketplace',
      component: Home,
      children: marketPlaceRoutes,
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
})
